module.exports = __webpack_public_path__ + "static/media/person.6b47f9e7.svg";